import React from "react";
import { Box } from "@chakra-ui/core";

export default (props) => (
  <Box borderBottomWidth="1px" my={4} {...props} />
);
